		 					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class ChecklistService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Checklist');
	}
	
	loadAllMasters(): Observable<TooBig4Car.Logic.Checklist[]> {
		return this.myBaseService.loadAll(this.url + '/Masters');
	}
	save(tempItem: TooBig4Car.Logic.Checklist) : Observable<TooBig4Car.Logic.Checklist> {
		return this.myBaseService.save(tempItem, this.url);
	}
	copy(tempItem: TooBig4Car.Logic.CopyChecklistVM): Observable<TooBig4Car.Logic.Checklist> {
		var url: string = this.url + '/Copy';
		return this.myBaseService.post(tempItem, url, true);
	}

	assign(tempItem: TooBig4Car.Logic.CopyChecklistVM): Observable<TooBig4Car.Logic.Checklist> {
		var url: string = this.url + '/Assign';
		return this.myBaseService.post(tempItem, url, true);
	}

	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.Checklist> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.Checklist>{
		return this.myBaseService.get(id, this.url);
	}
	download(id: System.Guid): Observable<BlobResponse>{
		return this.myBaseService.postBlob(null,this.url + '/Export/' + id);
	}
	search(searchObj: TooBig4Car.Logic.SearchVM) : Observable<TooBig4Car.Logic.Checklist[]>{
		return this.myBaseService.post(searchObj, this.url + '/Search', true);
	}
}
				
